/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { InvoiceEmailPathParams, InvoiceEmailResponse } from '../types/InvoiceEmail'

/**
 * POST /:organisation/invoices/:invoice/send-email
 * @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::email
 */
export async function invoiceEmail(
	organisation: InvoiceEmailPathParams['organisation'],
	invoice: InvoiceEmailPathParams['invoice'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InvoiceEmailResponse>> {
	return axiosInstance.post(`/${organisation}/invoices/${invoice}/send-email`, undefined, config)
}
